export const getUser = (state) => state.user.user
export const getUserLoader = (state) => state.user.isLoading
export const getPdfLink = (state) => state.questions.pdfLink
export const getActiveLanguage = (state) => state.user.language
export const getStateCountries = (state) => state.user.countries
export const getMailMessage = (state) => state.user.mailMessage